/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'language-lua': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10.5 5A8.5 8.5 0 002 13.5a8.5 8.5 0 008.5 8.5 8.5 8.5 0 008.5-8.5A8.5 8.5 0 0010.5 5m3 8a2.5 2.5 0 01-2.5-2.5A2.5 2.5 0 0113.5 8a2.5 2.5 0 012.5 2.5 2.5 2.5 0 01-2.5 2.5m6-11A2.5 2.5 0 0017 4.5 2.5 2.5 0 0019.5 7 2.5 2.5 0 0022 4.5 2.5 2.5 0 0019.5 2"/>'
  }
})
